import { FC } from 'react'
import { Link, WithStyleOverrides } from '@opallabs/lapidary'
import { assetProxyDownloadUrl } from '@opallabs/routing'
import { AssetReference } from '../Asset/types'

export type AssetDownloadLinkProps = Readonly<
  WithStyleOverrides & { assetReference?: AssetReference }
>

export const AssetDownloadLink: FC<
  React.PropsWithChildren<AssetDownloadLinkProps>
> = ({ assetReference, children, styleOverrides }) => {
  const { filename = '', uuid } = assetReference ?? {}
  return (
    <Link
      download={filename}
      href={uuid ? assetProxyDownloadUrl({ uuid }) : ''}
      target="_blank"
      rel="noopener noreferrer"
      styleOverrides={styleOverrides}
    >
      {children}
    </Link>
  )
}
